module.exports = "/images/dj.svg?1cc4b54271c7f1e181351724b5465154";